import HeaderNav from '@/components/HeaderNav'
import FooterMap from '@/components/FooterMap'
import GoTop from '@/components/GoTop'

const components = {
    install: function (Vue) {
        Vue.component("HeaderNav", HeaderNav)
        Vue.component("FooterMap", FooterMap)
        Vue.component("GoTop", GoTop)
    }
}
export default components


// WEBPACK FOOTER //
// ./src/components/components.js